module.exports = __webpack_public_path__ + "static/img/temperature.209d5ceb.png";